import carrierZoneModule from "./carrierZoneModule"
import template from "./carrier-zone-template.html"

carrierZoneModule.directive("nlgCarrierZone", [()=>{
    return {
        restrict: "E",
        transclude: true,
        template
    }
}])